import { getStatsObservable, getStatsEpic } from './getStats'

export const observables = {
  getStatsObservable,
}

export default {
  getStatsEpic,
}
